import { app } from "../../../namespaces";
import React, { Component, Fragment } from "reactn";
import {
    DialogActions,
    Button,
    MenuItem,
    Select,
    Icon,
    TextField
} from "@material-ui/core";
import { BeautifulDialog, DialogContent, ShowMessageDialog } from "../../components/Dialogs/BaseDialog";
import { ColGrid, FlexBox } from "../../components/LayoutGrid";
import { trackActivity } from "js/core/utilities/utilities";
import { Gap10, Gap20 } from "../../components/Gap";
import { BlueButton } from "../../components/UiComponents";

const EVENT_CATEGORY = "OnboardingSurvey";

function MarketingFormSelect(props) {
    return (
        <Select
            style={{ marginLeft: 15, border: "solid 1px #ccc" }}
            value={props.value}
            onChange={props.onChange}
            displayEmpty
            disableUnderline
            className={props.value == "" ? "placeholder" : ""}
            inputProps={{ className: "select-input", style: { fontSize: 20 } }}
        >
            <MenuItem value="" disabled>
                {props.placeholder}
            </MenuItem>
            {props.children}
        </Select>
    );
}

export default class MarketingInfoForm extends Component {
    constructor() {
        super();
        this.state = {
            userType: "",
            companyType: "",
            department: "",
            companySize: "",
            role: "",
            discovery: ""
        };

        trackActivity(EVENT_CATEGORY, "Started", null, null, {}, { audit: true });
    }

    submitForm = () => {
        let { userType, companyType, companyTypeOther, department, departmentOther, companySize, role, discovery, discoveryOther } = this.state;

        let isComplete = false;
        switch (userType) {
            case "work":
                isComplete = companyType != "" && department != "" && companySize != "" && role != "" && discovery != "";
                break;
            case "education":
                isComplete = role != "" && companyType != "" && discovery != "";
                break;
            case "personal":
                isComplete = discovery != "";
                break;
        }

        if (!isComplete) {
            ShowMessageDialog({
                title: "You left some questions unanswered",
                message: "We know you are excited to get started creating beautiful presentations but your information really helps us understand who and why people are using Beautiful.ai. Thank you so much for helping us out!"
            });

            return;
        }

        if (companyTypeOther) {
            companyType = "other:" + companyTypeOther;
        }
        if (departmentOther) {
            department = "other:" + departmentOther;
        }

        if (discoveryOther) {
            discovery = "other:" + discoveryOther;
        }

        const props = {
            userType: userType,
            companyType,
            department,
            role,
            companySize,
            discovery
        };

        app.user.update({
            userInfo: { ...props }
        });

        trackActivity(EVENT_CATEGORY, "Complete", Object.values(props).join("|"), null, props, { audit: true });

        this.props.closeDialog();
    };

    closeDialog = () => {
        this.props.closeDialog();
    };

    handleChange = (prop, value) => {
        let newState = { ...this.state, [prop]: value };

        this.setState({ [prop]: value });

        if (prop == "userType" && value != "personal") {
            this.setState({
                companyType: "",
                companySize: "",
                department: "",
                role: ""
            });
        }
    };

    renderDiscoveryQuestion(index) {
        return (
            <Fragment>
                <div className="question">
                    <div className="prompt">
                        <span className="list-num">{index}</span>How did you hear about Beautiful.ai?
                    </div>
                    <MarketingFormSelect
                        value={this.state.discovery}
                        onChange={event => this.handleChange("discovery", event.target.value)}
                        placeholder="Choose"
                    >
                        <MenuItem value="search">Search</MenuItem>
                        <MenuItem value="recommendation">Recommended by friend or colleague</MenuItem>
                        <MenuItem value="social">Social media</MenuItem>
                        <MenuItem value="blog">Blog or article</MenuItem>
                        <MenuItem value="viewed">Saw a Beautiful.ai presentation</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                    </MarketingFormSelect>
                </div>
                {this.state.discovery == "other" &&
                    <Fragment>
                        <Gap10 />
                        <FlexBox left style={{ marginLeft: 45 }}>
                            <TextField
                                autoFocus
                                fullWidth
                                variant="outlined"
                                placeholder="Please tell us where you heard about Beautiful.ai"
                                onChange={event => this.handleChange("discoveryOther", event.target.value)}
                            />
                        </FlexBox>
                    </Fragment>
                }
            </Fragment>
        );
    }

    render() {
        let { userType, companyType, department, companySize, role } = this.state;

        return (
            <BeautifulDialog
                closeDialog={this.props.closeDialog}
                maxWidth="md"
                fullWidth={false}
                hideBackdrop={false}
                preventClose
            >
                <div className="dialog-banner" style={{ minWidth: 700 }}>Please tell us a bit about yourself...</div>
                <DialogContent className="marketing-info-dialog">

                    <h3>
                        <span className="list-num">1</span>What will you be using Beautiful.ai for?
                    </h3>

                    <ColGrid gap={10} style={{ marginLeft: 45 }}>
                        <Button
                            disableRipple
                            variant={userType == "work" ? "contained" : "outlined"}
                            color={userType == "work" ? "primary" : "secondary"}
                            onClick={() => this.handleChange("userType", "work")}
                        >
                            <Icon style={{ marginRight: 6, fontSize: 19 }}>work</Icon>
                            Work
                        </Button>
                        <Button
                            disableRipple
                            variant={userType == "education" ? "contained" : "outlined"}
                            color={userType == "education" ? "primary" : "secondary"}
                            onClick={() => this.handleChange("userType", "education")}
                        >
                            <Icon style={{ marginRight: 6, fontSize: 19 }}>school</Icon>
                            School/Education
                        </Button>
                        <Button
                            disableRipple
                            variant={userType == "personal" ? "contained" : "outlined"}
                            color={userType == "personal" ? "primary" : "secondary"}
                            onClick={() => this.handleChange("userType", "personal")}
                        >
                            <Icon style={{ marginRight: 6, fontSize: 19 }}>accessibility_new</Icon>
                            Personal
                        </Button>
                    </ColGrid>

                    <Gap10 />

                    {userType == "work" && (
                        <Fragment>
                            <div className="question">
                                <div className="prompt">
                                    <span className="list-num">2</span>What kind of company is it?
                                </div>
                                <MarketingFormSelect
                                    value={companyType}
                                    onChange={event => this.handleChange("companyType", event.target.value)}
                                    placeholder="Choose your type of company"
                                >
                                    <MenuItem value="consumer_goods">Consumer Goods</MenuItem>
                                    <MenuItem value="creative_agency">Creative Agency</MenuItem>
                                    <MenuItem value="education">Education</MenuItem>
                                    <MenuItem value="financial_services">Financial Services</MenuItem>
                                    <MenuItem value="government">Government</MenuItem>
                                    <MenuItem value="healthcare">Healthcare/Pharmaceutical</MenuItem>
                                    <MenuItem value="legal">Legal</MenuItem>
                                    <MenuItem value="media">Media</MenuItem>
                                    <MenuItem value="nonprofit">Nonprofit</MenuItem>
                                    <MenuItem value="services">Professional services</MenuItem>
                                    <MenuItem value="retail">Retail</MenuItem>
                                    <MenuItem value="real_estate">Real Estate</MenuItem>
                                    <MenuItem value="technology">Software/Technology</MenuItem>
                                    <MenuItem value="other">Other</MenuItem>
                                </MarketingFormSelect>
                            </div>

                            {companyType == "other" &&
                                <Fragment>
                                    <Gap10 />
                                    <FlexBox left style={{ marginLeft: 45 }}>
                                        <TextField
                                            autoFocus
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Please describe your company"
                                            onChange={event => this.handleChange("companyTypeOther", event.target.value)}
                                        />
                                    </FlexBox>
                                </Fragment>
                            }

                            <div className="question">
                                <div className="prompt">
                                    <span className="list-num">3</span>What is your role there?
                                </div>
                                <MarketingFormSelect
                                    value={role}
                                    onChange={event => this.handleChange("role", event.target.value)}
                                    placeholder="Choose your title"
                                >
                                    <MenuItem value="executive">Executive</MenuItem>
                                    <MenuItem value="vp">VP</MenuItem>
                                    <MenuItem value="director">Director</MenuItem>
                                    <MenuItem value="manager">Manager</MenuItem>
                                    <MenuItem value="individual">Individual Contributor</MenuItem>
                                    <MenuItem value="consultant">Consultant</MenuItem>
                                </MarketingFormSelect>

                                <MarketingFormSelect
                                    value={department}
                                    onChange={event => this.handleChange("department", event.target.value)}
                                    placeholder="Choose your department"
                                >
                                    <MenuItem value="administrative">Administrative</MenuItem>
                                    <MenuItem value="owner">Business Owner</MenuItem>
                                    <MenuItem value="customer_support">Customer Support</MenuItem>
                                    <MenuItem value="designer">Designer</MenuItem>
                                    <MenuItem value="finance">Finance</MenuItem>
                                    <MenuItem value="hr">HR/Recruiting</MenuItem>
                                    <MenuItem value="it">IT/Security</MenuItem>
                                    <MenuItem value="legal">Legal</MenuItem>
                                    <MenuItem value="marketing">Marketing</MenuItem>
                                    <MenuItem value="communications">Media/Communications</MenuItem>
                                    <MenuItem value="operations">Operations</MenuItem>
                                    <MenuItem value="product">Product</MenuItem>
                                    <MenuItem value="sales">Sales</MenuItem>
                                    <MenuItem value="engineer">Engineering</MenuItem>
                                    <MenuItem value="other">Other</MenuItem>
                                </MarketingFormSelect>
                            </div>

                            {department == "other" &&
                                <Fragment>
                                    <Gap10 />
                                    <FlexBox style={{ marginLeft: 45 }}>
                                        <TextField
                                            autoFocus
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Please describe your department"
                                            onChange={event => this.handleChange("departmentOther", event.target.value)}
                                        />
                                    </FlexBox>
                                </Fragment>
                            }

                            <div className="question">
                                <div className="prompt">
                                    <span className="list-num">4</span>How big is your company?
                                </div>
                                <MarketingFormSelect
                                    value={companySize}
                                    onChange={event => this.handleChange("companySize", event.target.value)}
                                    placeholder="Choose your company size"
                                >
                                    <MenuItem value="1">Just me</MenuItem>
                                    <MenuItem value="2-10">2-10</MenuItem>
                                    <MenuItem value="11-50">11-50</MenuItem>
                                    <MenuItem value="51-500">51-250</MenuItem>
                                    <MenuItem value="250-1000">250-1000</MenuItem>
                                    <MenuItem value="1000+">1000+</MenuItem>
                                </MarketingFormSelect>
                            </div>

                            {this.renderDiscoveryQuestion(5)}

                        </Fragment>
                    )}

                    {userType == "education" && (
                        <div>
                            <div className="question">
                                <div className="prompt">
                                    <span className="list-num">2</span>Please describe yourself
                                </div>

                                <MarketingFormSelect
                                    value={role}
                                    onChange={event => this.handleChange("role", event.target.value)}
                                    placeholder="Choose your role"
                                >
                                    <MenuItem value="student">Student</MenuItem>
                                    <MenuItem value="teacher">Teacher/Professor</MenuItem>
                                    <MenuItem value="administrator">Staff/Administrator</MenuItem>
                                </MarketingFormSelect>
                            </div>

                            <div className="question">
                                <div className="prompt">
                                    <span className="list-num">3</span>What level is your school?
                                </div>
                                <MarketingFormSelect
                                    value={companyType}
                                    onChange={event => this.handleChange("companyType", event.target.value)}
                                    placeholder="Choose your school level"
                                >
                                    <MenuItem value="college">College/University</MenuItem>
                                    <MenuItem value="k-12">K-12</MenuItem>
                                    <MenuItem value="other">Other</MenuItem>
                                </MarketingFormSelect>
                            </div>
                            {this.renderDiscoveryQuestion(4)}
                        </div>
                    )}

                    {userType == "personal" && (
                        <Fragment>
                            {this.renderDiscoveryQuestion(2)}
                            <Gap20 />
                            <div className="question" style={{ marginLeft: 0 }}>
                                <span className="list-num">3</span>
                                <TextField
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Anything you'd like to share about how you plan to use Beautiful.ai?"
                                />
                            </div>
                        </Fragment>
                    )}

                </DialogContent>
                <DialogActions>
                    {userType != "" && (
                        <BlueButton onClick={this.submitForm} color="primary">
                            Finish
                        </BlueButton>
                    )}
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
